import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { Card, Modal } from 'antd';
import BasicSettings from './basicSettings';
import RecruitPageSettings from './recruitPageSettings';
import { get, groupBy } from 'lodash';
import { getParamInUrl, setParamInUrl } from '@/utils';
import { useMount } from 'ahooks';
import RewardSettings from '@/pages/backend/cardCampSettings/rewardSettings/index';
import FinishRuleSettings from '@/pages/backend/cardCampSettings/FinishRuleSettings';
import BatchSettings from '@/pages/backend/cardCampSettings/BatchSettings';
import EntryFormConfig from '@/pages/backend/EntryFormConfig';
import styles from './index.less';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import NodeSettings from '@/pages/backend/cardCampSettings/nodeSettings/index';
import { CardCampSettingContext } from './CardCampSettingContext';

export type UncommittedProps = {
  hasUncommitted: boolean;
  setHasUncommitted: (hasUncommitted: boolean) => void;
};

function CardCampSettings() {
  const [activeTabKey1, setActiveTabKey1] = useState<string>('basic');
  const [hasUncommitted, setHasUncommitted] = useState(false);
  const tabList = [
    {
      key: 'basic',
      tab: '基本信息',
      component: <BasicSettings />,
    },
    {
      key: 'form',
      tab: '报名表单',
      component: (
        <EntryFormConfig hasUncommitted={hasUncommitted} setHasUncommitted={setHasUncommitted} />
      ),
    },
    {
      key: 'admissions',
      tab: '招生页',
      component: <RecruitPageSettings />,
    },
    {
      key: 'node',
      tab: '打卡节点',
      component: <NodeSettings />,
    },
    //{
    //  key: 'quiz',
    //  tab: '每日小练',
    //  component: <p>content5</p>,
    //},
    {
      key: 'reward',
      tab: '打卡奖励',
      component: <RewardSettings />,
    },
    {
      key: 'rules',
      tab: '结营规则',
      component: (
        <FinishRuleSettings hasUncommitted={hasUncommitted} setHasUncommitted={setHasUncommitted} />
      ),
    },
    {
      key: 'class',
      tab: '批次管理',
      component: <BatchSettings />,
    },
  ];
  const [modal, contextHolder] = Modal.useModal();

  const contentList = useMemo(() => {
    const obj = groupBy(tabList, (item) => item.key);
    let res: Record<string, ReactNode> = {};
    for (const key in obj) {
      res[key as string] = obj[key][0].component;
    }
    return res;
  }, []);
  const onTab1Change = (key: string) => {
    console.log('key是', key);
    if (hasUncommitted) {
      modal
        .confirm({
          title: '当前页面内容未保存',
          icon: <ExclamationCircleOutlined />,
          content: '离开此页面将丢失变更的内容',
          okText: '离开',
          cancelText: '关闭',
        })
        .then(
          (confirmed) => {
            if (confirmed) {
              setActiveTabKey1(key);
              setParamInUrl('tab', key);
              setHasUncommitted(false);
            }
          },
          () => {},
        );
    } else {
      setActiveTabKey1(key);
      setParamInUrl('tab', key);
    }
  };
  useMount(() => {
    const tab = getParamInUrl('tab');
    if (tab) {
      setActiveTabKey1(tab);
    }
  });

  useEffect(() => {
    const onBeforeUnload = (event: { returnValue: string }) => {
      if (hasUncommitted) {
        event.returnValue = '当前页面内容未保存';
      }
    };

    window.addEventListener('beforeunload', onBeforeUnload, false);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload, false);
    };
  }, [hasUncommitted]);

  return (
    <CardCampSettingContext.Provider
      value={{
        onFormChange: (tempHasUncommitted) => {
          setHasUncommitted(tempHasUncommitted);
        },
      }}
    >
      <Card
        className={styles.CardWrapper}
        style={{ width: '100%' }}
        tabList={tabList}
        activeTabKey={activeTabKey1}
        onTabChange={onTab1Change}
      >
        {contextHolder}
        {get(contentList, `${activeTabKey1}`)}
      </Card>
    </CardCampSettingContext.Provider>
  );
}

export default CardCampSettings;
